import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  data: [],
  currentPage: null,
  message: ''
};

export const pageSlice = createSlice({
  name: 'pageSliceName',
  initialState,
  reducers: {
    getPages: (state) => {
      state.loading = true;
    },
    getOnePage: (state) => {
      state.loading = true;
    },
    addPage: (state) => {
      state.loading = true;
    },
    updatePage: (state) => {
      state.loading = true;
    },
    removePage: (state) => {
      state.loading = true;
    },
    successPages: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    successOnePage: (state, action) => {
      state.loading = false;
      state.currentPage = action.payload;
    },
    failedPages: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    }
  }
});

export const { getPages, getOnePage, addPage, updatePage, removePage, successPages, successOnePage, failedPages } = pageSlice.actions;

export default pageSlice.reducer;
